import { useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useSearch } from '../../../context/SearchContext';

const SEARCHABLE_ROUTES = new Set([
    '/', '/home', '/home/banners', '/home/bloques', '/movies', '/series',
    '/catalogos/directores', '/catalogos/actores', '/catalogos/ponentes-evento-live',
    '/eventos-live', '/catalogos/personajes', '/catalogos/premios',
    '/catalogos/nominations', '/catalogos/classifies', '/catalogos/dealers',
    '/catalogos/rights', '/catalogos/genres', '/catalogos/tags', '/users',
    '/minisites', '/settings/categories', '/blog', '/catalogos/blocks',
    '/promocodes', '/ratings', '/catalogos/awards-categories', '/catalogos/awards',
    '/catalogos/nav-menu'
]);

const SearchBox = () => {

    const { pathname } = useLocation();
    const [input, setInput] = useState(''); // State to store the input value
    const { updateSearchTerm } = useSearch(); // Get the updateSearchTerm function from the context

    useEffect(() => {
        setInput('');
        updateSearchTerm('');
    }, [pathname, updateSearchTerm]);

    const handleSearch = () => { // Handle the search button click
        updateSearchTerm(input); // Call the updateSearchTerm function with the input value
    };

    const handleKeyDown = (event) => { // Handle the Enter key press
        if (event.key === 'Enter') {
            updateSearchTerm(input);
        }
    };

    const handleChange = (event) => { // Handle the input change
        const value = event.target.value;
        setInput(value);
        // If the input is empty, update the search term to an empty string
        if (value.trim() === '') {
            updateSearchTerm('');
        }
    };

    const renderInputBox = () => {
        return (
            <input
                type="text"
                className="form-control search-input-modern"
                placeholder="Buscar..."
                value={input}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                style={{
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "#fff",
                    borderRadius: "20px",
                    padding: "0.25rem 0.8rem",
                    fontSize: "0.85rem",
                    height: "2rem",
                    transition: "all 0.3s ease",
                }}
            />
        );
    }

    const renderSearchButton = () => {
        return (
            <div className="input-group-append">
                <span className="input-group-text" style={{ background: 'transparent', border: 'none', marginLeft: '-40px', zIndex: 10 }}>
                    <button 
                        type="button"
                        aria-label="Buscar"
                        onClick={handleSearch} 
                        style={{ color: "#8743DF", background: 'none', border: 'none', padding: 0 }}
                    >
                        <i className="flaticon-381-search-2" />
                    </button>
                </span>
            </div>
        );
    }

    if (!SEARCHABLE_ROUTES.has(pathname)) return null;

    return (
        <div className="input-group search-area d-xl-inline-flex">
            {renderInputBox()}
            {renderSearchButton()}
        </div>
    );
};

export default SearchBox;